import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ApiRequestError, changePassword } from '../lib/api';
import { AuthShell, PasswordField } from '../components/AuthShell';

/**
 * Kotelezo jelszovaltas az elso belepeskor.
 *
 * NEM dialogus, hanem TELJES kepernyo, es az `app-layout` rendereli a chat
 * helyett. Egy bezarhato ablakot meg lehetne kerulni; ezt nem - es pont ez a
 * lenyeg: az ideiglenes jelszo egy levelben utazott, azt le kell cserelni,
 * mielott barmit is csinal a felhasznalo.
 */
export function ChangePasswordScreen({ minLength = 12 }: { minLength?: number }) {
  const queryClient = useQueryClient();

  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [again, setAgain] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const mismatch = again.length > 0 && next !== again;
  const tooShort = next.length > 0 && next.length < minLength;
  const canSubmit = current && next.length >= minLength && next === again && !busy;

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);

    try {
      await changePassword(current, next);
      // A szerver uj session-tokent adott: innentol a rendes felulet jon.
      await queryClient.invalidateQueries({ queryKey: ['session'] });
    } catch (err) {
      setError(err instanceof ApiRequestError ? err.message : 'A jelszóváltás nem sikerült.');
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Adj meg egy új jelszót" subtitle="Az ideiglenes jelszót le kell cserélni">
      <form onSubmit={(event) => void submit(event)} className="space-y-3">
        <PasswordField
          label="Jelenlegi (ideiglenes) jelszó"
          value={current}
          autoComplete="current-password"
          autoFocus
          onChange={setCurrent}
        />

        <PasswordField
          label="Új jelszó"
          value={next}
          onChange={setNext}
          hint={`Legalább ${minLength} karakter. Egy hosszú, könnyen megjegyezhető mondat a legjobb.`}
        />

        <PasswordField label="Új jelszó még egyszer" value={again} onChange={setAgain} />

        {tooShort && (
          <p className="text-xs text-ink-muted">Még {minLength - next.length} karakter kell.</p>
        )}
        {mismatch && <p className="text-xs text-danger">A két jelszó nem egyezik.</p>}

        {error && (
          <p className="rounded-control border border-danger/30 bg-danger-soft px-3 py-2.5 text-sm text-danger">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={!canSubmit}
          className="w-full rounded-control bg-accent px-4 py-3 font-semibold text-accent-ink transition-colors hover:bg-accent-hover disabled:opacity-50"
        >
          {busy ? 'Mentés…' : 'Jelszó beállítása'}
        </button>
      </form>
    </AuthShell>
  );
}
